export default {
  title: "Valida tu INE",
  verifyTitle: "Escanea tu INE",
  verify: "Verificar",
  noIne: "No tengo INE",
  getIneTitle: "Obtener INE",
  getIneCardTitle: "Obtén tu identificación oficial del INE",
  getIneDescription:
    "En esta página podrás encontrar el acceso directo al sitio oficial del Instituto Nacional Electoral (INE), donde podrás consultar los requisitos, agendar una cita y realizar los trámites necesarios para obtener tu credencial para votar. Serás redirigido de forma segura al portal oficial para completar tu proceso de manera rápida y confiable.",
  getIneButton: "Obtener",
  disconnect: "Desconectar",
  disconnectModal: {
    title: "Salir del registro",
    message: "Vas a salir del registro con el correo",
    warning: "Si sales tendrás que volver a iniciar el registro",
    alternative: "Si prefieres usar otro correo, crea un nuevo registro",
    confirm: "Sí, salir",
    cancel: "Continuar registro",
  },
  loading: "Cargando...",
  retry: "Reintentar",
  retryTitle: "Vuelve a intentarlo",
  retryDeclinedCardTitle: "No hemos podido validar tu identidad",
  retryDeclinedCardMessage:
    "Para que no vuelva a fallar: repite el proceso en un sitio bien iluminado, asegúrate de que en el selfie no salgan más personas y comprueba que tu INE se vea nítida y sin reflejos.",
  retryExpiredCardTitle: "La sesión ha caducado",
  retryExpiredCardMessage:
    "Tu verificación ha caducado antes de completarse. Vuelve a intentarlo para continuar con tu registro.",
  retryAbandonedCardTitle: "Verificación incompleta",
  retryAbandonedCardMessage:
    "No completaste el proceso de verificación. Vuelve a intentarlo para terminar tu registro.",
}
